











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Patient } from "../../../../domain/patient";
import { IButtonState, NavigationPane } from "../../../panes";
import { ExternalMenuMixin } from "../../../system/mixins";
import { ExternalMenuButton } from "../../../system";
import { EditingDocument } from "..";

@Component({
  components: {
    NavigationPane,
    ExternalMenuButton,
  },
})
export default class DocumentExternalMenu extends Mixins(ExternalMenuMixin) {
  @Prop()
  document: EditingDocument;

  get patient(): Patient {
    return this.document
      ? this.document.attributes.patient
      : null;
  }

  get isDocumentInitialized(): boolean {
    return !!this.document && this.document.isAlreadyInitialized;
  }

  get buttons(): IButtonState[] {
    const source = this.createParameterSource();
    source.patientId = this.patient ? this.patient.id : null;
    source.documentId = this.document ? this.document.source.documentId : null;

    return Enumerable.from(this.$configuration.behavior.document.editor.externalMenus)
      .select(menu => this.toButtonState(menu, !this.isDocumentInitialized, source))
      .toArray();
  }
}
